import { Outlet } from "@tanstack/react-router";
import { Box, Flex } from "@chakra-ui/react";
import { AuthActions, AuthGate } from "./auth";
import { Sidebar } from "./components/Sidebar";

export function App() {
  return (
    <AuthGate>
      <Flex direction={{ base: "column", lg: "row" }} minH="100vh" bg="bg">
        <Sidebar footer={<AuthActions />} />
        <Box as="main" minH="100vh" flex="1" bg="bg.subtle">
          <Outlet />
        </Box>
      </Flex>
    </AuthGate>
  );
}

export default App;
